import axios from 'axios'
import {
  ClientModel,
  ResponseCRUD,
  ResponseObject,
  ResponseObjectPaginated,
  ResponseObjectURL,
  TableResumen,
} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL
export function getClient(dto: ClientModel, page: number) {
  return axios.post<ResponseObjectPaginated<ClientModel[]>>(`${BASEURL}/client/getAll/${page}`, dto)
}

export function getClientById(dto: any) {
  return axios.get<ResponseObject<ClientModel>>(
    `${BASEURL}/client/getInformationById?clientId=${dto}`,
  )
}

export function createClient(dto: ClientModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/client/createClient`, dto)
}

export function deleteClient(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/client/deleteClient?id=${dto}`)
}

export function updateClient(dto: ClientModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/client/updateClient`, dto)
}

// INICIO ---- SERVICIOS MASIVE

export function downloadTemplateClient() {
  return axios.post<ResponseObjectURL>(
    `${BASEURL}/client/downloadTemplateBulkLoad_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function uploadMasiveClient(dto: any) {
  return axios.post<ResponseObjectPaginated<TableResumen[]>>(`${BASEURL}/client/bulkLoad`, dto)
}

// FIN ---- SERVICIOS MASIVE
